var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPositionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 0.59375V4.34375M11.0596 18.4062V22.1562M21.8643 11.3828H18.1143M4.00488 11.3828H0.254883M19.0792 11.375C19.0792 15.8121 15.4822 19.409 11.0452 19.409C6.60816 19.409 3.01123 15.8121 3.01123 11.375C3.01123 6.93799 6.60816 3.34106 11.0452 3.34106C15.4822 3.34106 19.0792 6.93799 19.0792 11.375ZM15.0454 11.375C15.0454 13.5842 13.2546 15.375 11.0454 15.375C8.83628 15.375 7.04541 13.5842 7.04541 11.375C7.04541 9.16587 8.83628 7.375 11.0454 7.375C13.2546 7.375 15.0454 9.16587 15.0454 11.375Z",
    stroke: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionIcon);
export default __webpack_public_path__ + "static/media/positionIcon.82e8a53d3c4b5302baa89d0db4c247ad.svg";
export { ForwardRef as ReactComponent };